<template>
  <div class="business" @mouseover="stop" @mouseout="start">
    <h3>服务范围</h3>
    <div class="container" ref="box">
      <div class="rolling" :style="{ left: left + 'px', width: w + 'px' }">
        <router-link
          :to="'/layout/news/' + item.categoryId"
          v-for="item in businessList"
          :key="item.categoryId"
        >
          <div class="service">
            <div class="imgbox">
              <img
                :src="$store.state.baseUrl + 'images/' + item.categorySmallimg"
                alt
              />
            </div>
            <span class="name">
              {{ item.categoryTitle }}
              <span style="color: #246dab; font-size: 12px; margin-left: 2px"
                >></span
              >
            </span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      businessList: [],
      left: 0,
      t: "",
      w: 0,
      isRoll: false,
    };
  },
  computed: {
    ...mapGetters(["getCategoryAppid"]),
  },
  watch: {
    getCategoryAppid(id) {
      this.getBusinessList(id);
    },
  },
  mounted() {
    this.getBusinessList(this.$store.state.categoryAppid);
  },
  methods: {
    ...mapActions(["findSonTrees"]),
    getBusinessList(id) {
      this.findSonTrees({
        basicCategoryid: 52,
        categoryAppid: id,
      }).then((res) => {
        // console.log(res)
        this.left = 0;
        window.cancelAnimationFrame(this.t);
        var businessList = res.data;
        // console.log(this.businessList)
        let w = res.data.length * 81;
        if (w > this.$refs.box.clientWidth) {
          let copy = JSON.parse(JSON.stringify(businessList));
          copy.forEach((item, index) => {
            copy[index].categoryId = item.categoryId * 10;
          });
          this.businessList = businessList.concat(copy);
          this.w = this.businessList.length * 81;
          this.rolling();
          this.isRoll = true;
        } else {
          this.businessList = res.data;
          this.w = this.businessList.length * 81;
        }
        // this.rolling()
      });
    },
    //滚动
    rolling() {
      var that = this;
      function step() {
        that.left--;
        if (that.left == (-1 / 2) * that.w) {
          that.left = 0;
        }
        that.t = window.requestAnimationFrame(step);
      }
      that.t = window.requestAnimationFrame(step);
    },
    start() {
      if (this.isRoll) {
        this.rolling();
      }
    },
    stop() {
      if (this.isRoll) {
        window.cancelAnimationFrame(this.t);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.business {
  margin: 40px 0px;
  h3 {
    text-align: center;
    padding: 10px;
    border-bottom: 3px solid #018fd7;
    margin-bottom: 10px;
  }
  .container {
    width: 100%;
    height: 130px;
    overflow: hidden;
    position: relative;
    .rolling {
      height: 130px;
      position: absolute;
    }
    a {
      width: 61px;
      height: 130px;
      margin: 0 10px;
      color: #000;
      float: left;
      display: block;
    }
    .service {
      // border: solid 1px #999;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 130px;
      .imgbox {
        width: 100%;
        height: 60px;
      }
      .name {
        width: 100%;
        height: 20px;
        line-height: 20px;
        margin: 5px 0;
        font-size: 6px;
      }
    }
  }
}
</style>
